// import { ResultOf } from "gql.tada";
// import { RotaryCarouselSectionById } from "@queries/entries/RotaryCarouselSectionById";
import { useIsDesktop } from "@hooks/useIsDesktop";
import Carousel, { Slide } from "@components/shared/RotaryCarousel";

export const VerticalRotaryCarousel = ({
  entry: { rotaryCarouselSection: entry },
  title
}: {
  entry: any;
  title: string;
}) => {
  const isDesktop = useIsDesktop();

  if (!entry?.items?.length) {
    return null;
  }
  const slides: Slide[] = entry.items.map((item: any) => {
    return {
      content: item?.title ?? "",
      video: item?.item?.media?.url,
    } as Slide;
  });


  if (!slides?.length) {
    return null;
  }
  return (
    <section className="flex flex-col gap-8 items-center justify-center py-20">
      <div className="w-full flex justify-center items-center">
        <div className="min-h-max w-full">
          {title &&
            <h3 className="text-palette-current-highlight font-['Netflix_Sans_Title'] font-medium text-[80px] dsk:text-[128px] text-center mb-[80px] dsk:mb-[-100px] tracking-[-2.56px]">
              {title}
            </h3>
          }
          <Carousel
            slides={slides}
            slideWidth={isDesktop ? 400 : 200}
            slideHeight={isDesktop ? 710 : 356}
            variant="vertical"
            gap={isDesktop ? 300 : 35}
            accessibilityControlLabelNext={entry.accessibilityControlLabelNext}
            accessibilityControlLabelPrevious={
              entry.accessibilityControlLabelPrevious
            }
          />
        </div>
      </div>
    </section>
  );
};
